import React from 'react'
import { OneManDeliveryIcon, TwoManDeliveryIcon } from '@sainsburys-tech/bolt-icons'
import { useBrandConfigContext } from '../../../providers/BrandConfigContext/BrandConfigContext'
import FulfilmentSkeleton from '../FulfilmentSkeleton'
import { DeliveryFee } from './DeliveryFee'
import { DeliveryTrolleyButton } from './DeliveryTrolleyButton'
import { DeliveryAvailability } from './DeliveryAvailability'
import { DeliveryForm } from './DeliveryForm'
import DeliveryEmail from './DeliveryEmail/DeliveryEmail'

import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

import * as Styled from './DeliveryBox.styles'

const determineFeatureType = attributes => {
  const {
    globallyOutOfStock,
    endOfLineOutOfStock,
    preorderUnavailable,
    inStoreJewelleryItem,
    digitalDownload,
    twoManDeliveryUnavailable
  } = attributes
  return (
    globallyOutOfStock ||
    endOfLineOutOfStock ||
    preorderUnavailable ||
    inStoreJewelleryItem ||
    digitalDownload ||
    twoManDeliveryUnavailable
  )
}

const hideFulfimentHeader = (deliverable, collectable, collectionMessage, deliveryMessage) =>
  (!deliverable && !collectable) ||
  ((collectable ? !!collectionMessage : true) && (deliverable && !collectable ? !!deliveryMessage : true))

const generateDeliverableCollectable = (hasFeatureType, deliveryCollectable, deliveryDeliverable) => {
  const collectable = deliveryCollectable && !hasFeatureType
  const deliverable = deliveryDeliverable && !hasFeatureType
  return [collectable, deliverable]
}
const DeliveryBox = ({
  props: deliveryProps,
  showDeliveryForm,
  searchDelivery,
  deliverySearchTerm,
  updateDeliverySearchTerm,
  onShowDeliveryForm,
  findButtonText,
  addToTrolley,
  updateIsInitialMount
}) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()
  const {
    storeLocator: { deliveryPostcode, deliveryLoading, deliveryMessage, collectionMessage, deliveryIcon },
    productStore: {
      data: { badges }
    },
    productList
  } = deliveryProps

  const isClearance = badges?.some(badge => {
    return badge.attributes.badgeReference === 'CLEARANCE_BADGE'
  })
  const [collectable, deliverable] = generateDeliverableCollectable(
    determineFeatureType(deliveryProps.attributes),
    deliveryProps.attributes.collectable,
    deliveryProps.attributes.deliverable
  )
  const HIDE_FULFILMENT_HEADER = hideFulfimentHeader(deliverable, collectable, collectionMessage, deliveryMessage)

  const deliveryAvailabilityProps = {
    showDeliveryForm,
    deliveryIcon,
    deliveryMessage,
    deliveryPostcode
  }

  const deliveryFeeProps = {
    attributes: {
      fulfilmentAgent: deliveryProps.attributes.fulfilmentAgent,
      deliveryPrice: deliveryProps.attributes.deliveryPrice,
      fastTrack: deliveryProps.attributes.fastTrack,
      freeDelivery: deliveryProps.attributes.freeDelivery,
      variableDeliveryPrice: deliveryProps.attributes.variableDeliveryPrice,
      sdf: deliveryProps.attributes.sdf
    },
    deliveryIcon,
    showDeliveryForm
  }

  const partNumber = deliveryProps?.attributes?.partNumber

  const deliveryTrolleyButtonProps = {
    addToTrolley,
    showDeliveryForm,
    onShowDeliveryForm,
    deliveryIcon,
    partNumber,
    trolleyButtonTracking: deliveryProps.trolleyButtonTracking,
    trolleyButtonOnErrorTracking: deliveryProps.trolleyButtonOnErrorTracking,
    productList
  }

  const deliveryFormProps = {
    showDeliveryForm,
    deliverySearchTerm,
    updateDeliverySearchTerm,
    findButtonText,
    searchDelivery,
    deliveryProps,
    updateIsInitialMount,
    deliverable
  }

  const { EMAIL_ME_BACK = {} } = useBrandConfigContext()
  const { excludedSkus = [], position = '' } = EMAIL_ME_BACK

  const isDeliveryBoxPosition = position === 'deliveryBox'
  const isOOS = deliveryIcon === 'out_of_stock'
  const isExcludedSku = excludedSkus.includes(partNumber)

  const SHOW_EMAIL_ME_BACK = isDeliveryBoxPosition && isOOS && !isClearance && !isExcludedSku

  const deliveryEmailProps = {
    postcode: deliveryPostcode,
    productId: partNumber
  }

  return (
    HIDE_FULFILMENT_HEADER &&
    deliverable && (
      <Styled.FulfilmentDeliveryContainer
        data-test='fulfilment-delivery-box'
        className={PDP_V2_FLAG && !collectable ? '' : 'top-border'}
      >
        {deliveryLoading && <FulfilmentSkeleton />}
        {!deliveryLoading && deliverable && (
          <Styled.FulfilmentDeliveryHeader data-test='fulfilment-delivery-header'>
            {collectable && <OneManDeliveryIcon width={24} height={24} />}
            {!collectable && <TwoManDeliveryIcon width={24} height={24} />}
            <Styled.FulfilmentDeliveryTitle data-test='delivery-title'>Delivery</Styled.FulfilmentDeliveryTitle>
          </Styled.FulfilmentDeliveryHeader>
        )}

        {!deliveryLoading && (
          <Styled.FulfilmentMessagePanel data-test='fulfilment-msg-panel'>
            <DeliveryAvailability {...deliveryAvailabilityProps} />
            <DeliveryFee {...deliveryFeeProps} />
            <DeliveryTrolleyButton {...deliveryTrolleyButtonProps} />
            <DeliveryForm {...deliveryFormProps} />
            {SHOW_EMAIL_ME_BACK && <DeliveryEmail {...deliveryEmailProps} />}
          </Styled.FulfilmentMessagePanel>
        )}
      </Styled.FulfilmentDeliveryContainer>
    )
  )
}

export default DeliveryBox
